import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { isQueryReady } from "src/api/axiosClient/utils";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { z } from "zod";
import { CampaignSchema } from "src/api/client-api/useCampaign";

export const getAllSsqVersionAssignmentsKey = "getAllSsqVersionAssignments" as const;

export const useGetAllSsqVersionAssignments = (ssqId: number | undefined) => {
    const isEnabled = ssqId !== undefined;

    const query = useQuery({
        enabled: isEnabled,
        queryKey: [getAllSsqVersionAssignmentsKey, ssqId],
        queryFn: async () => {
            const response = await loggedInApiCall.get("/api/ssq-version-assignments", {
                params: { ssqId },
            });
            const members = response.data["hydra:member"];
            return zodParseWithDetailedLog(members, SsqVersionAssignmentSchema.array(), {
                operation: "GET",
                endpoint: "/ssq_version_assignments",
            });
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        assignments: query.data ?? [],
        isReady,
        ...query,
    };
};

const SsqVersionAssignmentSchema = z.object({
    id: z.number(),
    ssqId: z.number(),
    ssqVersionId: z.number(),
    campaign: CampaignSchema,
    linkedEntityNames: z.array(z.string()),
    ssqPostCount: z.number(),
    answerCount: z.number(),
    relatedActionPlansCount: z.number(),
});

export type SsqVersionAssignment = z.infer<typeof SsqVersionAssignmentSchema>;
